<div class="__toggle-group">
  <ng-content />
</div>
